export class ClearExpiration {
    static readonly type = '[Auth] ClearExpiration';
}
